<template>
  <div>Deslogando....</div>
</template>

<script>
export default {
   mounted(){
       this.deslogar()
   },
   methods:{
       deslogar(){
           localStorage.removeItem("token")
           sessionStorage.removeItem("token")
           localStorage.removeItem("trocaPerfil")
           location.href = '/login'
       }
   }
}
</script>

<style>

</style>